import { cx } from 'class-variance-authority';
import type { PropsWithChildren } from 'react';

import { Table, TableBody } from '../Table';

interface CompareModelsTableProps {
  readonly tableBodyClassName?: string;
}

const CompareModelsTable = ({
  children,
  tableBodyClassName,
}: PropsWithChildren<CompareModelsTableProps>) => {
  return (
    <Table className="w-full" unstyled>
      <TableBody className={cx('flex flex-col gap-y-5', tableBodyClassName)}>
        {children}
      </TableBody>
    </Table>
  );
};

export default CompareModelsTable;
